/**
 * 设备详情
 * 创建时间：2017-02-22
 * 修改人：baixx
 * 修改时间：2017-03-31
 */
<template>
	<div class="pl10px pr10px">	
	    <div class="form-horizontal">
	 		<div class="form-group">
				<label class="col-sm-1 control-label ">设备ID</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="displayDeviceid">
				</div>
				<label class="col-sm-1 control-label focus_color">*设备编号</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.deviceInfo.deviceNum.$error }">
					<input type="text" class="form-control" v-model.trim="deviceInfo.deviceNum" @input="$v.deviceInfo.deviceNum.$touch()">
					<span class="form-group__message cus_message" v-if="!$v.deviceInfo.deviceNum.required && $v.deviceInfo.deviceNum.$error">设备编号为必填项</span>
				</div>
				<label class="col-sm-1 control-label focus_color">*设备类型</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.deviceInfo.obdFlag.$error }">
					<select class="form-control" v-model="deviceInfo.obdFlag" @input="$v.deviceInfo.obdFlag.$touch()">
						<option v-for="option in OBDType" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
					<span class="form-group__message cus_message" v-if="!$v.deviceInfo.obdFlag.required && $v.deviceInfo.obdFlag.$error">设备类型为必填项</span>
				</div>		
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label focus_color">*品牌</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.deviceInfo.brandCode.$error }">
					<select class="form-control" v-model="deviceInfo.brandCode" @input="$v.deviceInfo.brandCode.$touch()">
						<option v-for="option in deviceBrand" v-bind:value="option.brandCode">
							{{ option.brandName }}
						</option>
					</select>

					<!--<input type="text" class="form-control" v-model="deviceInfo.brandCode" @input="$v.deviceInfo.brandCode.$touch()">-->
					<span class="form-group__message cus_message" v-if="!$v.deviceInfo.brandCode.required && $v.deviceInfo.brandCode.$error">品牌为必填项</span>
				</div>
				<label class="col-sm-1 control-label focus_color">*型号</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.deviceInfo.categoryId.$error }">
					<select class="form-control" v-model="deviceInfo.categoryId" @input="$v.deviceInfo.categoryId.$touch()">
						<option v-for="option in deviceCategory" v-bind:value="option.id">
							{{ option.categoryNo }}
						</option>
					</select>	
					<!--<input type="text" class="form-control" v-model="deviceInfo.categoryCode" @input="$v.deviceInfo.categoryCode.$touch()">-->
					<span class="form-group__message cus_message" v-if="!$v.deviceInfo.categoryId.required && $v.deviceInfo.categoryId.$error">型号为必填项</span>
				</div>
				<label class="col-sm-1 control-label focus_color">*有线无线</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.deviceInfo.wifiFlag.$error }">
					<select class="form-control" v-model="deviceInfo.wifiFlag" @input="$v.deviceInfo.wifiFlag.$touch()">
						<option v-for="option in wifiType" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
					<span class="form-group__message cus_message" v-if="!$v.deviceInfo.wifiFlag.required && $v.deviceInfo.wifiFlag.$error">有线无线为必填项</span>
				</div>		 
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label focus_color">*接线方式</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.deviceInfo.wiringMode.$error }">
					<select class="form-control" v-model="deviceInfo.wiringMode" @input="$v.deviceInfo.wiringMode.$touch()">
						<option v-for="option in wiringType" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
					<span class="form-group__message cus_message" v-if="!$v.deviceInfo.wiringMode.required && $v.deviceInfo.wiringMode.$error">接线方式为必填项</span>
				</div>
				<label class="col-sm-1 control-label focus_color">*设备协议</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.deviceInfo.protocolId.$error }">
					<select class="form-control" v-model="deviceInfo.protocolId" @input="$v.deviceInfo.protocolId.$touch()">
						<option v-for="option in protocol" v-bind:value="option.protocolId">
							{{ option.deviceProtocol }}
						</option>
					</select>
					<span class="form-group__message cus_message" v-if="!$v.deviceInfo.protocolId.required && $v.deviceInfo.protocolId.$error">设备协议为必填项</span>
				</div>
				
					 
			</div>
				
	   </div>
	    <div class="form-group mb5px">
			<div class="col-sm-12 text-right" v-if="levv==1" key="user-didi">
			  <button v-if="permissionD.indexOf('fileCarList_deviceDetailRefresh1') == -1" class="btn btn-primary" @click="refreshMileage">刷新</button>
			</div>	
			<div class="col-sm-12 text-right" v-else key="user-rb">
			  <button v-if="permission.indexOf('carFileList_deviceDetailRefresh1') == -1" class="btn btn-primary" @click="refreshMileage">刷新</button>
			</div>
		</div>
	    <div class="form-horizontal ibox-content">
			<div class="form-group">
				<label class="col-sm-1 control-label focus_color">*初始里程</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.deviceInfo.initMileage.$error }">
					<input type="text" class="form-control" v-model.trim="deviceInfo.initMileage" @input="$v.deviceInfo.initMileage.$touch()" maxlength="10">
					<span class="form-group__message cus_message" v-if="!$v.deviceInfo.initMileage.required && $v.deviceInfo.initMileage.$error">初始里程为必填项</span>
				</div>
				<label class="col-sm-1 control-label ">里程校准系数</label>
				<div class="col-sm-3"> 
					<input type="text" class="form-control" readonly v-model="deviceInfo.correctDiff">
				</div> 
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label ">OBD里程</label>  
				<div class="col-sm-2">
					<input type="text" class="form-control" readonly v-model="deviceInfo.obdMileage">
				</div>
				<div class="col-sm-1">
					<radio v-model="deviceInfo.mileageType" true-value="2" style="margin-top: 5px;"></radio>
				</div>
				<label class="col-sm-1 control-label ">GPS里程</label>
				<div class="col-sm-2"> 
					<input type="text" class="form-control" readonly v-model="deviceInfo.hardMileage">
				</div> 
				<div class="col-sm-1">
					<radio v-model="deviceInfo.mileageType" true-value="3" style="margin-top: 5px;"></radio>
				</div>
				<label class="col-sm-1 control-label ">软件里程</label>
				<div class="col-sm-2"> 
					<input type="text" class="form-control" readonly v-model="deviceInfo.totilMileage">
				</div> 
				<div class="col-sm-1">
					<radio v-model="deviceInfo.mileageType" true-value="1" style="margin-top: 5px;"></radio>
				</div>
			</div>
		</div>
			
		<!--无线设备-->
		<div v-if="deviceInfo.wifiFlag=='2'">
			<div class="form-group mb0px">
				<label class="col-sm-5 control-label gray t_left">无线设备定位上传时间</label>
			</div>
	
			<div class="form-horizontal ibox-content">
				<div class="form-group mb0px">
					<label class="col-sm-1 control-label ">模式设置</label>
					<div class="col-sm-3">
						<div class="input-group">
		                    <!--<input type="text" class="form-control" readonly v-model="deviceInfo.simBalance">--> 
		                    <select class="form-control" v-model="curInsts">
								<option v-for="option in insts" v-bind:value="option.id">
									{{ option.name }}
								</option>
							</select>
		                    <span class="input-group-btn"> 
		                    	<button type="button" class="btn btn-primary" @click="uploadModelSetting">设置</button> 
		                    </span>
		                </div>
					</div>
					<span class="col-sm-8 control-label gray t_left">目前仅用于GT740和BK200两种型号的设备</span>
				</div>
			</div>
			<!--<div class="form-horizontal ibox-content">
				<div class="form-group mb0px">
					<label class="col-sm-1 control-label focus_color">上传模式</label>
					<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.deviceInfo.sendModel.$error }">
						<select class="form-control" v-model="deviceInfo.sendModel" @input="$v.deviceInfo.sendModel.$touch()">
							<option v-for="option in sendType" v-bind:value="option.udccode">
								{{ option.udcname }}
							</option>
						</select>
						<span class="form-group__message cus_message" v-if="!$v.deviceInfo.sendModel.required && $v.deviceInfo.sendModel.$error">上传模式为必填项</span>
					</div>
					<label v-if="deviceInfo.sendModel=='1'" class="col-sm-1 control-label focus_color">上传时间</label>
					<div v-if="deviceInfo.sendModel=='1'" class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="deviceInfo.sendTime">
					</div>
					<label v-if="deviceInfo.sendModel=='1'" class="col-sm-1 control-label focus_color">上传间隔</label>
					<div v-if="deviceInfo.sendModel=='1'" class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="deviceInfo.sendInterval">
						<p class="help-block">单位:分</p>
					</div>
					
					<label v-if="deviceInfo.sendModel=='2'" class="col-sm-1 control-label focus_color">上传时间</label>
					<div v-if="deviceInfo.sendModel=='2'" class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="deviceInfo.sendTime">
						<p class="help-block">多个时间以逗号分割</p>
					</div>
					
					<label v-if="deviceInfo.sendModel=='3'" class="col-sm-1 control-label focus_color">上传星期</label>
					<div v-if="deviceInfo.sendModel=='3'" class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="deviceInfo.sendWeek">
						<p class="help-block">多个时间以逗号分割</p>
					</div>
					<label v-if="deviceInfo.sendModel=='3'" class="col-sm-1 control-label focus_color">上传时间</label>
					<div v-if="deviceInfo.sendModel=='3'" class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="deviceInfo.sendTime">
						<p class="help-block">单位:时</p>
					</div>
				</div>
			</div>	-->
					
			<div class="hr-line-dashed" style="background:#DDDDDD;color:#fff;"></div>
		</div>
			
		<!--有线设备-->
		<div v-if="deviceInfo.wifiFlag=='1'">
			<div class="form-group mb0px">
				<label class="col-sm-5 control-label gray t_left">有线设备定位上传时间</label>
			</div>	
			<div class="form-horizontal ibox-content">
				<div class="form-group mb0px">
					<label class="col-sm-1 control-label focus_color">*上传间隔</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="deviceInfo.sendInterval">
						<p class="help-block">单位:秒</p>
					</div>
				</div>
			</div>				
			<div class="hr-line-dashed" style="background:#DDDDDD;color:#fff;"></div>
		</div>

		<div class="form-group mb5px mt5px">
			<label class="col-sm-5 control-label gray t_left">设备当前位置</label>
			<div class="col-sm-7 text-right" v-if="levv==1" key="user-didi">
			  <button v-if="permissionD.indexOf('fileCarList_deviceDetailRefresh2') == -1" class="btn btn-primary" @click="refreshMileage">刷新</button>
			</div>
			<div class="col-sm-7 text-right" v-else key="user-rb">
			  <button v-if="permission.indexOf('carFileList_deviceDetailRefresh2') == -1" class="btn btn-primary" @click="refreshMileage">刷新</button>
			</div>	
		</div>	
		<div class="form-horizontal ibox-content">
			<div class="form-group"> 
				<label class="col-sm-1 control-label">经度</label>
				<div class="col-sm-3">
					<input type="text" class="form-control"  readonly v-model="devicePosition.lat">
				</div>
				<label class="col-sm-1 control-label ">纬度</label>   
				<div class="col-sm-3">
					<input type="text" class="form-control"  readonly v-model="devicePosition.lng">
				</div>
				<label class="col-sm-1 control-label ">更新时间</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="devicePosition.gpsTime">
				</div>		 
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label ">当前地址</label>
				<div class="col-sm-11">
					<input type="text" class="form-control" readonly v-model="devicePosition.address">
				</div>		 
			</div>
		</div>
		
		<div class="hr-line-dashed" style="background:#DDDDDD;color:#fff;"></div>
		<div class="form-group mb0px">
			<label class="col-sm-5 control-label gray t_left">SIM卡信息</label>
		</div>	
		
		<div class="form-horizontal ibox-content">
			<div class="form-group">
				<label class="col-sm-1 control-label focus_color">*SIM卡号</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.deviceInfo.simNum.$error }">
					<input type="text" class="form-control" v-model.trim="deviceInfo.simNum" @input="$v.deviceInfo.simNum.$touch()" maxlength="13">
					<span class="form-group__message cus_message" v-if="!$v.deviceInfo.simNum.required && $v.deviceInfo.simNum.$error">SIM卡号为必填项</span>
				</div>
				<label class="col-sm-1 control-label ">运营商</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.simOperators">
				</div>	
				<label class="col-sm-1 control-label ">归属地</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.simAttribution">
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label focus_color">*卡类型</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.deviceInfo.simType.$error }">
					<select class="form-control" v-model="deviceInfo.simType" @input="$v.deviceInfo.simType.$touch()">
						<option v-for="option in simType" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
					<!--<input type="text" class="form-control" v-model="deviceInfo.simType" @input="$v.deviceInfo.simType.$touch()">-->
					<span class="form-group__message cus_message" v-if="!$v.deviceInfo.simType.required && $v.deviceInfo.simType.$error">卡类型为必填项</span>
				</div>
				<label class="col-sm-1 control-label ">激活时间</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="deviceInfo.activeDate">
				</div>	
				<label class="col-sm-1 control-label ">卡资费</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.simCharge">
				</div>
			</div>                                       
			<div class="form-group">
				<label class="col-sm-1 control-label ">代缴期限</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.payPeriodName">
				</div>
				<label class="col-sm-1 control-label ">缴费类型</label>
				<div class="col-sm-3"> 
					<input type="text" class="form-control" readonly v-model="deviceInfo.paymentModeName">
				</div>	
				<label class="col-sm-1 control-label ">充值次数</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.rechargeTimes">
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label ">充值到期时间</label>  
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.expiredDate">
				</div>
				<label class="col-sm-1 control-label ">下次充值时间</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.nextDate">
				</div>	
				<label class="col-sm-1 control-label ">当前流量(M)</label>
				<div class="col-sm-3">
					<div class="input-group">
	                    <input type="text" class="form-control" readonly v-model="deviceInfo.simBalance"> 
						<span class="input-group-btn" v-if="levv==1" key="user-didi"> 
	                    	<button v-if="permissionD.indexOf('fileCarList_deviceDetailRefresh3') == -1" type="button" class="btn btn-primary" @click="reflashSimBalance">刷新</button> 
	                    </span>
	                    <span class="input-group-btn" v-else key="user-rb"> 
	                    	<button v-if="permission.indexOf('carFileList_deviceDetailRefresh3') == -1" type="button" class="btn btn-primary" @click="reflashSimBalance">刷新</button> 
	                    </span>
	                </div>
				</div>
			</div>
			<div class="form-group mb0px">
				<label class="col-sm-1 control-label ">所属平台</label>  
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.sourceName">
				</div>					 
			</div>
		</div>
		<div class="hr-line-dashed" style="background:#DDDDDD;color:#fff;"></div>
		<div class="form-group mb0px">
			<label class="col-sm-5 control-label gray t_left">设备安装信息</label>
		</div>	
		
		<div class="form-horizontal ibox-content">
			<div class="form-group">
				<label class="col-sm-1 control-label ">安装人</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.installer">
				</div>
				<label class="col-sm-1 control-label">安装时间</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.installDate">
				</div>
				<label class="col-sm-1 control-label ">安装方式</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.installTypeName">
				</div>		 
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label ">安装地点</label>
				<div class="col-sm-11">
					<input type="text" class="form-control" readonly v-model="deviceInfo.installAddress">
				</div>
			</div>	
			<div class="form-group">
				<label class="col-sm-1 control-label ">安装位置</label> 
				<div class="col-sm-11">
					<input type="text" class="form-control" readonly v-model="deviceInfo.installLocation">
					<p class="help-block">仅用于记录设备的安装位置，仅安装人可见</p>
				</div>
			</div>	
			<div class="form-group">
				<label class="col-sm-1 control-label ">安装图片</label>
			</div>	
		</div>	
		<br>
		<div class="form-horizontal">
			<div class="form-group t_center mb0px" v-if="levv==1" key="user-didi">
				<button v-if="permissionD.indexOf('fileCarList_deviceDetailSave') == -1" class="btn btn-primary" @click="saveInfo" :disabled="!enableSubmit">保存</button>
			</div>
			<div class="form-group t_center mb0px" v-else key="user-rb">
				<button v-if="permission.indexOf('carFileList_deviceDetailSave') == -1" class="btn btn-primary" @click="saveInfo" :disabled="!enableSubmit">保存</button>
			</div>
		</div>
		
		<tab-modal size="normal" ref="modal1" v-on:cancel="closeModal1" :title="insts[curInsts].name">
			<div v-show="!next">
				<div>
					<component :is="insts[curInsts].component" ref="instComp" @nextClick="instNextStep" @withdrawBtn="closeModal1"></component>
				</div>
			</div>
			<div v-show="next">
				<div>
					<p>您将要发送{{insts[curInsts].name}}指令</p>
					<p>确定要继续吗？</p>
				</div>
				<div slot="footer" class="text-right">
					<button v-if="next" class="btn btn-primary" @click="closeModal1">取消</button> 
					<button v-if="next" class="btn btn-primary" @click="dispatchIns">确定</button>
				</div>
			</div>
		</tab-modal>
	</div> 
</template>
<script>
	import {DICTIONARY_MAP} from 'static/constant'
	import TabModal from 'components/common/TabModal'
	import { required } from 'vuelidate/lib/validators'
	import { OPERATE_EXCEPTION,OPERATE_SUCCESS} from 'static/message'
	import {getDictionaryFromArray} from 'util/util'
	import Radio from 'components/common/Radio'
	
	import InsGT740AlarmClockModeSet from 'components/pages/vehiclemonitor/instructions/InsGT740AlarmClockModeSet'
	import InsGT740DefaultedModeSet from 'components/pages/vehiclemonitor/instructions/InsGT740DefaultedModeSet'
	import InsGT740GSMOpenSet from 'components/pages/vehiclemonitor/instructions/InsGT740GSMOpenSet'
	import InsGT740WeekModeSet from 'components/pages/vehiclemonitor/instructions/InsGT740WeekModeSet'
	import InsBKAlarmClock from 'components/pages/vehiclemonitor/instructions/InsBKAlarmClock'
	
	import classlist from 'util/classlist'
	export default{
		name:'DetailInfo',
		components: {
	    	Radio,
	    	TabModal,
	    	InsGT740AlarmClockModeSet,
	    	InsGT740DefaultedModeSet,
	    	InsGT740GSMOpenSet,
	    	InsGT740WeekModeSet,
	    	InsBKAlarmClock
	    },
		data(){
			return {
				permission:this.$store.state.permission.permission["carFileList"]?this.$store.state.permission.permission["carFileList"]:[],
				permissionD:this.$store.state.permission.permission["fileCarList"]?this.$store.state.permission.permission["fileCarList"]:[],
				displayDeviceid:'',
				deviceInfo:{
					deviceNum:'',					//设备编号
					obdFlag:'',						//设备类型
					brandCode:'',				    //设备品牌
					categoryId:'',			    	//型号
					wifiFlag:'',					//有线无线
					wiringMode:'',					//接线方式
					initMileage:'',					//初始里程
					obdMileage:'',					//OBD里程
					hardMileage:'',					//GPS里程
					totilMileage:'',			    //软件里程
					correctDiff:'',					//里程校准差
					sendModel:'',					//上传模式
					sendInterval:'',				//上传间隔
					sendTime:'',					//上传时间
					sendWeek:'',					//上传星期
					simNum:'',						//SIM卡号
					simOperators:'',				//运营商
					simAttribution:'',				//归属地
					simType:'',						//卡类型
					activeDate:'',                  //激活时间
					simCharge:'',					//卡资费
					payPeriod:'',					//代缴期限
					payPeriodName:'',
					paymentMode:'',
					paymentModeName:'',				//缴费类型
					rechargeTimes:'',				//充值次数
					expiredDate:'',					//充值到期时间
					nextDate:'',					//下次充值时间
					simBalance:'',					//流量余额
					source:'',						//所属平台
					sourceName:'',
					installer:'',					//安装人
					installDate:'',					//安装时间
					installType:'',					//安装方式
					installTypeName:'',
					installAddress:'',				//安装地点
					installLocation:'',				//安装位置
					id:'',							//设备ID
					protocolId:'',
					mileageType:'',					//里程类型
				},
				devicePosition:{					//设备当前位置
					lat:'',
					lng:'',
					gpsTime:'',
					address:''
				},
				categoryId:'',						//暂时存在值
				protocolId:'',						//暂时存在值
				deviceBrand:[],                      //设备品牌下拉框
				deviceCategory:[],					//设备型号下拉列表
				OBDType:[],							//设备类型列表
				wifiType:[],						//有线无线列表
				wiringType:[],						//接线方式列表
				simType:[],
				sendType:[],						//上传模式列表
				protocol:[],                        //设备协议下拉
				udcType:[
					DICTIONARY_MAP.WIRING_MODE,		  //接线方式
					DICTIONARY_MAP.IS_WIRELESS,       //有线无线
					DICTIONARY_MAP.SIM_TYPE,		  // sim卡类型
					DICTIONARY_MAP.OBD_FLAG,		  //obd类型(类型)
					DICTIONARY_MAP.SEND_MODEL
			
				],                          //字典
				insts:[{
					name: "",
					id:0
				}],
				instsGT740:[{
						name:"GSM常开模式设置",
						id:0,
						component:"InsGT740GSMOpenSet"
					},{
						name:"默认模式设置",
						id:1,
						component:"InsGT740DefaultedModeSet"
					},{
						name:"星期模式设置",
						id:2,
						component:"InsGT740WeekModeSet"
					},{
						name:"闹钟模式设置",
						id:3,
						component:"InsGT740AlarmClockModeSet"
					}
				],
				instsBK200:[{
						name:"设置终端闹钟上报模式",
						id:"0",
						component:"InsBKAlarmClock"
					}
				],
				curInsts:0,
				next:false,
				cmdStr:[],
				showSubPage:false
			}
		},
		beforeMount() {
			this.getUdc();
			this.refreshMileage();
		},
		watch:{
			'deviceInfo.brandCode'(val,oldval){
				this.getDeviceCategory(val);
			},
			'deviceInfo.categoryId'(val){
				if(val == 22){			// GT740
					this.insts = this.instsGT740;
				} else if (val == 40){  // BK200
					this.insts = this.instsBK200;
				} else {
					this.insts = [{
						name: "",
						id:0
					}]
				}
			},
			showSubPage(val){
				if(val) {
					classlist.toggleScroll('close','#device-detail',this);
				}else{
					classlist.toggleScroll('open','#device-detail',this);
				}
			}
		},
		validations: {
			deviceInfo:{
				deviceNum:{
					required
				},
				protocolId:{
					required
				},
				obdFlag:{
					required
				},
				brandCode:{
					required
				},
				categoryId:{
					required
				},
				wifiFlag:{
					required
				},
				wiringMode:{
					required
				},
				initMileage:{
					required
				},
				sendModel:{
					required
				},
				sendTime:{
					required
				},
				sendWeek:{
					required
				},
				sendInterval:{
					required
				},
				simNum:{
					required
				},
				simType:{
					required
				}
			}
		},
		computed: {
			levv(){
				return this.$store.state.user.levv
			},
			enableSubmit: function(){
				let status = false;
				if (this.deviceInfo.wifiFlag=='1'){
					status = this.$v.deviceInfo.sendInterval.required;
				}
				if (this.deviceInfo.wifiFlag=='2'){
					if (this.deviceInfo.sendModel=='1'){
						status = this.$v.deviceInfo.sendTime.required&&this.$v.deviceInfo.sendInterval.required;
					}
					if (this.deviceInfo.sendModel=='2'){
						status = this.$v.deviceInfo.sendTime.required;
					}
					if (this.deviceInfo.sendModel=='3'){
						status = this.$v.deviceInfo.sendTime.required&&this.$v.deviceInfo.sendWeek.required;
					}
				}
				return this.$v.deviceInfo.deviceNum.required && this.$v.deviceInfo.obdFlag.required 
					&& this.$v.deviceInfo.brandCode.required&& this.$v.deviceInfo.categoryId.required
					&& this.$v.deviceInfo.wifiFlag.required&& this.$v.deviceInfo.wiringMode.required
					&& this.$v.deviceInfo.initMileage.required&& this.$v.deviceInfo.sendModel.required
					&& this.$v.deviceInfo.simNum.required&& this.$v.deviceInfo.simType.required&&status;
					
			}
		},
		
		
		methods: {	
			// 获取设备基本详情：服务卡号，里程，城市
			getDeviceInfo(){
				this.$http.get(process.env.API_ROOT + "/vehicle/vehicles/" + this.$parent.queryparam.vehicleid +"/devices/"+this.$parent.queryparam.deviceid)
				.then( res => {
					if(res.data.success){
						this.deviceInfo = res.data.data;
						this.displayDeviceid = 'VD' + this.deviceInfo.id;
						this.categoryId=this.deviceInfo.categoryId;
						this.protocolId=this.deviceInfo.protocolId;
					} else {
						this.$parent.openModal(res.body.message);
					}
				}, res => {
					this.$parent.openModal(res.body.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})
			},
			//刷新SIM卡余额
			reflashSimBalance(){
				this.$http.put(process.env.API_ROOT + '/vehicle/vehicles/'+this.$parent.queryparam.vehicleid+'/devices/'+this.$parent.queryparam.deviceid+'/sim-datausage')
				.then( res => {
					if(res.body.success){
						this.deviceInfo.simBalance = res.body.data;
					}else{
						this.$parent.openModal(res.body.message);
					}
				}, res => {
						this.$parent.openModal(res.body.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})
			},
			// 获取设备品牌下拉列表
			getDeviceBrand(){
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/devices/brands')
				.then( res => {
					if(res.data.success){
						this.deviceBrand= res.data.data;
						this.getDeviceInfo();
					}else{
						this.$parent.openModal(res.body.message);
					}
					this.$parent.loadingstatus += 1;
				}, res => {
						this.$parent.openModal(res.body.message);
						this.$parent.loadingstatus += 1;
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
					this.$parent.loadingstatus += 1;
				})	
			},
			getDeviceCategory(val){
				if(typeof(val)=="undefined")return;
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/devices/brands/'+val)
				.then( res => {
					if(res.data.success){
						this.deviceCategory= res.data.data;
						this.deviceInfo.categoryId = this.categoryId
					}else{
						this.$parent.openModal(res.body.message);
					}
				}, res => {
						this.$parent.openModal(res.body.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})	
			},
			getProtocol(){
				this.$http.get(process.env.API_ROOT + '/system/device-protocol')
				.then( res => {
					if(res.data.success){
						this.protocol= res.data.data.list;
						this.deviceInfo.protocolId=this.protocolId
					}else{
						this.$parent.openModal(res.body.message);
					}
					this.$parent.loadingstatus += 1;
				}, res => {
						this.$parent.openModal(res.body.message);
						this.$parent.loadingstatus += 1;
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
					this.$parent.loadingstatus += 1;
				})	
			},
			getUdc(){
				if(this.udcType.length ==0) return;			
				let param = this.udcType.join(',');
				this.$http.get(process.env.API_ROOT + '/system/udcs',{params:{udcTypes: param}})
				.then(res => {
					if(res.data.success){		
					 	this.OBDType = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.OBD_FLAG);
						this.wifiType = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.IS_WIRELESS);
						this.wiringType = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.WIRING_MODE);
						this.simType = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.SIM_TYPE);
						this.sendType =getDictionaryFromArray(res.data.data,DICTIONARY_MAP.SEND_MODEL);
						this.getProtocol();
						this.getDeviceBrand();
					}else{
						this.$parent.openModal(res.data.message);
					}
					this.$parent.loadingstatus += 1;
				}, res => {
					this.$parent.openModal(res.data.message);
					this.$parent.loadingstatus += 1;
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
					this.$parent.loadingstatus += 1;
				})		
			},
			//设备当前位置刷新
			refreshMileage(){
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/'+this.$parent.queryparam.vehicleid+'/devices/'+this.$parent.queryparam.deviceid+'/position',{params:{deviceId: this.$parent.queryparam.deviceid}})
				.then( res => {
					if(res.body.success){
						this.devicePosition.lat = res.body.data.lat;
						this.devicePosition.lng = res.body.data.lng;
						this.devicePosition.gpsTime = res.body.data.gpsTime;
						this.devicePosition.address = res.body.data.address;
					}else{
						this.$parent.openModal(res.body.message);
					}
				}, res => {
						this.$parent.openModal(res.body.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})
			},
			saveInfo(){	
				this.$http.put(process.env.API_ROOT + '/vehicle/vehicles/' + this.$parent.vehicleInfo.vehicleId+'/devices/'+this.deviceInfo.id, this.deviceInfo)
				.then( res => {
					if(res.data.success){
						this.$parent.openModal(OPERATE_SUCCESS);	
					} else {
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})
				
			},
			// 下发指令
			dispatchIns(){
				const obj =  {
						cmd:this.cmdStr.join(','),
						cmdName:this.insts[this.curInsts].name,
						cmdType:'0',
						deviceId:this.deviceInfo.id,
						source:'0',
						vehicleId:this.$parent.queryparam.vehicleid
				}
				this.$http.post(process.env.API_ROOT + '/monitor/instruction/instus/?cmd=' + obj.cmd + '&cmdName=' + obj.cmdName + '&cmdType=' + obj.cmdType + '&deviceId=' + obj.deviceId + '&source=0&vehicleId=' + obj.vehicleId)
				.then((response) => {
					this.$parent.openModal("指令发送成功");
					this.closeModal1();
//						that.delCmd = true;
				},(response)=>{
					this.$parent.openModal(response.body.message)
				})
				.catch((response)=>{
					this.$parent.openModal(OPERATE_EXCEPTION)
				})
			},
			// 点击设备上传时间
			uploadModelSetting(){
				if(!this.insts[this.curInsts].name) return;
				this.$refs.modal1.open();
				this.showSubPage = true;
				this.next = false;
			},
			closeModal1(){
				this.$refs.modal1.close();
				this.showSubPage = false;
			},
			instNextStep(params){
				this.cmdStr = params;
				this.next = true;
			}
		}
	}
</script>



// WEBPACK FOOTER //
// DetailInfo.vue?5ae34ebf